module.exports = __webpack_public_path__ + "img/1.3fb2c766.jpg";